import { render, staticRenderFns } from "./SubfolderDeArchive.vue?vue&type=template&id=3d46fb8d"
import script from "./SubfolderDeArchive.vue?vue&type=script&lang=js"
export * from "./SubfolderDeArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports